import SignUpForm from "components/users/SignUpForm";

export default function Signup() {
    return <SignUpForm />;
}
